<template>
    <div class="home">
        <b-container fluid>
            <h1>HRM Request Application</h1>
            <p v-html="welcomeText" style="margin-top:25px; margin-bottom:26px;"></p>

            <b-row>
                <b-col>
                    <b-button variant="primary" @click="login">Log in</b-button>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
import pageTitle from '@/mixins/pageTitle'
import axios from 'axios';


export default {
  title: 'HRM Request Application',
  
  data: () => ({
      welcomeText: ''
  }),
  created() {
      this.initialize()
  },
  mixins: [
    pageTitle
  ],
  methods: {
       initialize() {
           this.loadWelcomeText()
       },
       loadWelcomeText() {
            axios.get(`${process.env.VUE_APP_API_BASE_URL}/public/welcome`)
            .then(response => { this.welcomeText = response.data.value })
       },
       login () {
        window.location.replace('/home') 
      },
  }
}
</script>

<style>

</style>